import * as Sentry from '@sentry/react'
Sentry.init({
  release: import.meta.env.VITE_SENTRY_RELEASE || undefined,
  dsn: import.meta.env.VITE_SENTRY_DSN ? import.meta.env.VITE_SENTRY_DSN : undefined,
  // Adds request headers and IP for users, for more info visit:
  // https://docs.sentry.io/platforms/javascript/guides/react/configuration/options/#sendDefaultPii
  sendDefaultPii: true,
  enabled: import.meta.env.VITE_SENTRY_ENABLED === 'true',
  environment: import.meta.env.VITE_SENTRY_ENV,
})
